import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const {
      accordions,
      pxCorrection
    } = config;

    this.trigger = accordions;
    this.pxCorrection = pxCorrection;

    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;

    if (this.accordions && this.accordions.length !== 0) {
      this.bindEvents();

      const url = location.href;
      const id = url.split('#');

      if (!!id[1]) {
        const accordionToClick = document.querySelector(`#${id[1]} + .ns-accordion`);
        const accordionToScroll = document.querySelector('#' + id[1]);
        const headerOffset = document.querySelector('.header').offsetHeight;
        const elementPosition = accordionToScroll.offsetTop;
        const offsetPosition = elementPosition + headerOffset;
        if (accordionToClick) {
          const accordeonHeader = accordionToClick.querySelector('.ns-accordion__head');
          const accordeonHeaderHeight = accordeonHeader.offsetHeight;
          setTimeout(() => {
            accordeonHeader.click();
            window.scrollTo({
              top: (offsetPosition + accordeonHeaderHeight + this.pxCorrection),
              behavior: "smooth"
            });
          }, 1000);
        } else {
          setTimeout(() => {
            window.scrollTo({
              top: (offsetPosition + this.pxCorrection),
              behavior: "smooth"
            });
          }, 1000);
        }
      }
    }
  }

  bindEvents() {
    this.accordions.forEach(el => {
      el.addEventListener('click', (e) => {
        if(el.classList.contains('active')){
          Helper.slideClose(el.nextElementSibling);
          el.classList.remove('active');
        } else{
          this.accordions.forEach(accordion => {
            if(accordion.classList.contains('active')){
              Helper.slideClose(accordion.nextElementSibling);
              accordion.classList.remove('active');
            }
          });
          el.classList.add('active');
          Helper.slideOpen(el.nextElementSibling, true, 300);
          setTimeout(e => {
            el.scrollIntoView({block: "start", behavior: "smooth"});
          },300);
        }
        this.toggleAriaExpanded(el)
      });
    });
  }

  toggleAriaExpanded(button){
    let aria = button.getAttribute('aria-expanded');

    if(aria=="false"){
      aria = "true";
    } else{
      aria = "false";
    }
    button.ariaExpanded = aria;
  }
}

export default Accordion;
